export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '& '
	},
	{
		name: 'item',
		label: 'Item',
		selector: '& .item'
  },
	{
		name: 'item-image',
		label: 'Item Image',
		selector: '& .item img'
  },
	{
		name: 'item-first',
		label: 'First Item',
		selector: '& .item:first-child'
  },
	{
		name: 'item-next-to-first',
		label: 'Next to First Item',
		selector: '& .item:nth-child(2)'
  },
	{
		name: 'item-last',
		label: 'Last Item',
		selector: '& .item:last-child'
  },
	{
		name: 'item-next-to-last',
		label: 'Next to Last Item',
		selector: '& .item:nth-last-child(2)'
  }
]